import * as angular from "angular";

export class SubscriptionService {
    private v2Root: string;
    private $http: any;

    constructor($http: any) {
        this.$http = $http;
        this.v2Root = "/v2/subscription";
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/create", data);
    }

    plans(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/plans", { params: data });
    }

    planInfo(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/plan_info", { params: data });
    }

    paymentIntent(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/paymentintent/" + data.id, data);
    }

    setupIntent(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/setupintent", data);
    }

    setupIntentUpgrade(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/setupintentupgrade", data);
    }

    setupIntentSignup(data?: any): Promise<object> {
        return this.$http.get(this.v2Root + "/setupintentsignup", data);
    }

    promoCode(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/promo_code", { params: data });
    }

    upcoming_invoice(data?: any): Promise<object> {
        return this.$http.get(this.v2Root + "/upcoming_invoice", data);
    }

    card(): Promise<object> {
        return this.$http.get(this.v2Root + "/card");
    }

    paymentMethod(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/card", data);
    }

    paymentMethodUpgrade(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/cardupgrade", data);
    }

    applyPromo(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/apply_promo", data);
    }

    upgrade(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/upgrade", data);
    }

    essentials(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/essentials", data);
    }

    invoices(): Promise<object> {
        return this.$http.get(this.v2Root + "/invoices");
    }
}

angular
    .module("vcServices")
    .service("SubscriptionService", SubscriptionService);
